<template>
  <div class="home-events flex-col section">
    <homeTitleVue txt="EVENTS" toMore="/events" />
    <ul class="flex-row justify-between home-event-list" :class="styles">
      <li v-for="item in data" :key="item.id">
        <HomeEventBlockVue :data="item" />
      </li>
    </ul>
  </div>
</template>

<script>
import { computed, defineComponent } from "@vue/composition-api";
import homeTitleVue from "./home-title.vue";
import HomeEventBlockVue from "./HomeEventBlock.vue";
import { useFetchList } from "../../../hooks/fetch-list";
import { api } from "../../../utils/apis";
export default defineComponent({
  name: "HomeEvents",
  components: { homeTitleVue, HomeEventBlockVue },
  setup(props, ctx) {
    const { data } = useFetchList({
      api: api.events.list,
      initQuery: {
        page: 1,
        page_size: 4,
      },
      ctx,
    });
    const styles = computed(() => {
      return data.value.length < 4 ? "justify-start mr20" : "justify-between";
    });
    // 此处应该有防抖函数
    return {
      data,
      styles,
    };
  },
});
</script>
<style lang="scss" scoped>
.home-events {
  .home-event-list {
    padding: 0;
    margin-top: 30px;
  }
  .mr20 li {
    margin-right: 20px;
  }
}
</style>
